import { VStack } from '@chakra-ui/react';
import { FC } from 'react';

import { LectureAbstractMarkdown } from '@/components/ui/shared/markdowns/LectureAbstractMarkdown/LectureAbstractMarkdown';

interface IAiMarkdown {
  content: string;
}

export const AiMarkdown: FC<IAiMarkdown> = ({ content }) => {
  return (
    <VStack alignItems="left" spacing={7}>
      <LectureAbstractMarkdown source={content} />
    </VStack>
  );
};
